const initialState = {
   isFetching: true,
   isFetchingByFilter: false,
   isNextFetching: false,
   isEmpty: false,
   isEmptyByFilter: false,
   downloadsData: [],
   errors: null,
};

export default initialState;
